export default __webpack_public_path__ + "static/media/DuerfpDarkActive.8510a32b.svg";